import React, { useState } from "react";
import { Box, Collapse, Stack, Typography } from "@mui/material";
import { InternalJobMetaContent } from "./InternalJobMeta";
import { ViewNotesContent } from "./ViewNotesSection";

function TabHeader({ label, active, onClick, dense }) {
  return (
    <Typography
      onClick={onClick}
      variant="caption"
      color={active ? "primary.main" : "text.secondary"}
      sx={{
        fontWeight: 600,
        fontSize: dense ? "0.68rem" : "0.75rem",
        cursor: "pointer",
        userSelect: "none",
        textDecoration: active ? "underline" : "none",
      }}
    >
      {label}
    </Typography>
  );
}

// "Details" and "View Notes" act like tabs sharing one full-width content
// area below - mutually exclusive, and neither is open by default. Clicking
// the active tab again closes it (back to nothing shown).
export default function DetailsNotesTabs({ job, dense = false }) {
  const [activeTab, setActiveTab] = useState(null); // null | "details" | "notes"

  const toggleTab = (tab) => {
    setActiveTab((prev) => (prev === tab ? null : tab));
  };

  return (
    <Box onClick={(event) => event.stopPropagation()}>
      <Stack direction="row" spacing={2}>
        <TabHeader
          label="Details"
          active={activeTab === "details"}
          onClick={() => toggleTab("details")}
          dense={dense}
        />
        <TabHeader
          label="View Notes"
          active={activeTab === "notes"}
          onClick={() => toggleTab("notes")}
          dense={dense}
        />
      </Stack>

      <Collapse in={activeTab !== null} timeout="auto" unmountOnExit>
        <Box sx={{ mt: dense ? 0.5 : 0.75, width: "100%" }}>
          {activeTab === "details" ? (
            <InternalJobMetaContent job={job} dense={dense} />
          ) : null}
          {activeTab === "notes" ? (
            <ViewNotesContent job={job} dense={dense} />
          ) : null}
        </Box>
      </Collapse>
    </Box>
  );
}
